var _rect, _rect2, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var SvgPolygon = function SvgPolygon(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 50,
    fill: "#8247E5"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 50,
    fill: "url(#8247E5)",
    fillOpacity: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.635 13.906c-.474-.27-1.083-.27-1.625 0l-3.791 2.235-2.573 1.422-3.724 2.234c-.474.27-1.084.27-1.625 0l-2.912-1.76a1.65 1.65 0 0 1-.812-1.422v-3.386c0-.541.27-1.083.812-1.422l2.912-1.692c.474-.271 1.083-.271 1.625 0l2.911 1.76c.474.27.813.813.813 1.422v2.234l2.573-1.49V11.74c0-.542-.271-1.084-.813-1.422L12.99 7.136c-.474-.271-1.084-.271-1.625 0l-5.553 3.25c-.541.27-.812.812-.812 1.354v6.364c0 .542.27 1.084.813 1.422l5.484 3.182c.474.271 1.083.271 1.625 0l3.724-2.166 2.573-1.49 3.724-2.166c.474-.271 1.083-.271 1.625 0l2.911 1.692c.474.271.813.813.813 1.422v3.386c0 .541-.271 1.083-.813 1.421L24.635 26.5c-.474.27-1.083.27-1.625 0l-2.91-1.693a1.65 1.65 0 0 1-.813-1.421v-2.167l-2.573 1.49v2.234c0 .541.271 1.083.813 1.422l5.484 3.182c.474.27 1.084.27 1.625 0l5.485-3.182a1.65 1.65 0 0 0 .812-1.422V18.51c0-.541-.27-1.083-.812-1.421l-5.485-3.183Z",
    fill: "#fff"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "a",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "matrix(0 18 -18 0 18 18)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8247E5"
  })))));
};
export default SvgPolygon;